import Overview from "@/components/admin/Content/WebPages/Opportunities/Procurement/Overview";
import FullPageSpinner from "@/components/ui/FullPageSpinner";
import { useWebPageForm } from "@/contexts/WebPageFormContext";

const Procurement = () => {
  const { pageData, isLoading } = useWebPageForm();

  if (isLoading) {
    return <FullPageSpinner />
  }

  return (
    <div className="flex flex-col gap-8 lg:gap-12 p-4 md:p-8 lg:p-12 xl:w-3/4 mx-auto">
      <Overview data={pageData?.PROCUREMENT ?? {
        sectionTag: 'PROCUREMENT',
        contentType: 'WITHOUT_FILE',
        title: 'Procurement'
      }} />
    </div>
  )
}

export default Procurement